import {HttpClient, HttpParams} from '@angular/common/http';
import {AuthenticationService} from '@app/app/shared/services/authentication.service';
import {Component} from '@angular/core';
import * as moment from 'moment-timezone';
import {forkJoin} from 'rxjs/observable/forkJoin';
import {ParksFetcher} from '@app/app/shared/helpers/parks.fetcher';
import {WebHttpUrlEncodingCodec} from '@app/app/shared/helpers/web.http.url.encoding.codec';

@Component({
  selector: 'reports-conso',
  styleUrls: ['../reports.css'],
  templateUrl: './reports.conso.component.html'
})
export class ReportsConsoComponent {
  chartOptions = [];

  public types = [
    {id: 'water', label: 'Water Consumption'},
    {id: 'acid_chlorine', label: 'Acid/Chlorine'},
  ];

  public parks = [];
  public selectedPark1;
  public selectedPark2;
  public selectedFromDate1: Date;
  public selectedToDate1: Date;
  public selectedFromDate2: Date;
  public selectedToDate2: Date;

  public selectedType = '';

  public minDate = new Date(1960, 0, 1);
  public maxDate = new Date(2100, 0, 1);

  public isLoadingResults = false;

  public width = '100%';
  public height = 500;

  waterInterval = 'Daily';
  private echartsInstances = [];
  private isMoving = null;
  private timeout = null;

  constructor(private http: HttpClient, private auth: AuthenticationService, private parksFetcher: ParksFetcher) {

    this.selectedFromDate1 = moment().startOf('year').toDate();
    this.selectedToDate1 = moment().endOf('day').toDate();

    this.selectedFromDate2 = moment().startOf('year').toDate();
    this.selectedToDate2 = moment().endOf('day').toDate();

    this.selectedType = 'water';

    try {
      const parks = JSON.parse(sessionStorage.getItem('parks'));

      if (Array.isArray(parks) && parks.length > 0 && parks.length < 3) {
        this.selectedPark1 = parks[0];

        if (parks.length === 2) {
          this.selectedPark2 = parks[1];
        }
      }
    } catch (e) {
      console.log(e);
    }

    this.isLoadingResults = true;

    this.parksFetcher.retrieveParks().subscribe((res) => {
      this.parks = res;

      if (Array.isArray(this.parks) && this.parks.length > 0) {
        if (!this.selectedPark1) {
          this.selectedPark1 = this.parks[0].id;
        }

        this.setEndDate1({event: this.selectedToDate1});
      }
    }, (err) => {
      this.isLoadingResults = false;
    });
  }

  private getPark1Timezone() {
    const parks = this.parks.filter(park => park.id === this.selectedPark1);
    let timezone = 'UTC';

    if (parks.length === 1 && typeof parks[0].attributes !== 'undefined' && parks[0].attributes !== null) {
      timezone = parks[0].attributes.location.timezone;
    }

    return timezone;
  }

  setStartDate1(event) {
    this.selectedFromDate1 = moment(event.value).startOf('day').toDate();
    this.setEndDate2();
    this.reloadData();
  }

  setEndDate1(event) {
    const currentParkDate = moment.tz(this.getPark1Timezone()).endOf('hour');
    const selectedDate = moment(event.value);

    if (selectedDate.isSame(currentParkDate, 'day')) {
      const formattedDate = currentParkDate.format('YYYY-MM-DD HH:mm:ss.SSS');
      this.selectedToDate1 = moment(formattedDate, 'YYYY-MM-DD HH:mm:ss.SSS').toDate();
    } else {
      this.selectedToDate1 = moment(event.value).endOf('day').toDate();
    }

    this.setEndDate2();
    this.reloadData();

    // TODO: check end date is after
  }

  setStartDate2(event) {
    this.selectedFromDate2 = moment(event.value).startOf('day').toDate();
    this.setEndDate2();
    this.reloadData();
  }

  private setEndDate2() {
    const range = this.selectedToDate1.getTime() - this.selectedFromDate1.getTime();
    const newDate = this.selectedFromDate2.getTime() + range;

    this.selectedToDate2 = new Date(newDate);
  }

  setType(value) {
    this.selectedType = value;
    this.reloadData();
  }

  setPark1(value) {
    this.selectedPark1 = value;

    sessionStorage.setItem('parks', JSON.stringify([this.selectedPark1, this.selectedPark2].filter(p => p !== null && p !== '')));

    this.reloadData();
  }

  setPark2(value) {
    this.selectedPark2 = value;

    sessionStorage.setItem('parks', JSON.stringify([this.selectedPark1, this.selectedPark2].filter(p => p !== null && p !== '')));

    this.reloadData();
  }

  private prepareDate(date) {
    const formattedDate = moment(date).format('YYYY-MM-DD HH:mm:ss.SSS');
    const inUtc = moment.tz(formattedDate, 'YYYY-MM-DD HH:mm:ss.SSS', 'UTC');

    return inUtc.valueOf();
  }

  public onZoom(index, event) {
    if (this.isMoving !== null && this.isMoving !== index) {
      return;
    }

    if (this.isMoving === null) {
      this.isMoving = index;

      this.timeout = setTimeout(() => {
        this.isMoving = null;
      }, 500);
    }

    if (index === 0) {
      this.echartsInstances[1].dispatchAction({
        type: 'dataZoom',
        dataZoomIndex: 0,
        start: event.start,
        end: event.end
      });
    } else if (index === 1) {
      this.echartsInstances[0].dispatchAction({
        type: 'dataZoom',
        dataZoomIndex: 0,
        start: event.start,
        end: event.end
      });
    }
  }

  onChartInit(index, ec) {
    this.echartsInstances[index] = ec;
  }

  private prepareCaption(selectedType, index, selectedPark) {
    let c = '';

    if (selectedType === 'water') {
      c = 'Water Consumption for ';
    } else if (selectedType === 'acid_chlorine') {
      if (index === 0) {
        c = 'Acid Level for ';
      } else {
        c = 'Chlorine Level for ';
      }
    }

    const pId = (parseInt(selectedPark, 10) === 1) ? this.selectedPark1
      : (parseInt(selectedPark, 10) === 2) ? this.selectedPark2 : null;

    this.parks.forEach((park) => {
      if (park.id === pId) {
        c += park.attributes.name;
      }
    });

    return c;
  }

  private getWaterOverTime() {
    let params = new HttpParams({encoder: new WebHttpUrlEncodingCodec()})
      .set('type', 'water_consumption');

    if (this.selectedPark1) {
      params = params.append('parks[1]', this.selectedPark1)
        .append('from[1]', this.prepareDate(this.selectedFromDate1))
        .append('to[1]', this.prepareDate(this.selectedToDate1));
    }

    if (this.selectedPark2) {
      params = params.append('parks[2]', this.selectedPark2)
        .append('from[2]', this.prepareDate(this.selectedFromDate2))
        .append('to[2]', this.prepareDate(this.selectedToDate2));
    }

    return this.http.get<any>('/reports/conso', {params: params});
  }

  private getWaterCumulative() {
    let params = new HttpParams({encoder: new WebHttpUrlEncodingCodec()})
      .set('type', 'water_consumption')
      .set('cumulative', '1');

    if (this.selectedPark1) {
      params = params.append('parks[1]', this.selectedPark1)
        .append('from[1]', this.prepareDate(this.selectedFromDate1))
        .append('to[1]', this.prepareDate(this.selectedToDate1));
    }

    if (this.selectedPark2) {
      params = params.append('parks[2]', this.selectedPark2)
        .append('from[2]', this.prepareDate(this.selectedFromDate2))
        .append('to[2]', this.prepareDate(this.selectedToDate2));
    }

    return this.http.get<any>('/reports/conso', {params: params});
  }

  private getAcidOverTime() {
    let params = new HttpParams({encoder: new WebHttpUrlEncodingCodec()})
      .set('type', 'acid_level');

    if (this.selectedPark1) {
      params = params.append('parks[1]', this.selectedPark1)
        .append('from[1]', this.prepareDate(this.selectedFromDate1))
        .append('to[1]', this.prepareDate(this.selectedToDate1));
    }

    if (this.selectedPark2) {
      params = params.append('parks[2]', this.selectedPark2)
        .append('from[2]', this.prepareDate(this.selectedFromDate2))
        .append('to[2]', this.prepareDate(this.selectedToDate2));
    }

    return this.http.get<any>('/reports/conso', {params: params});
  }

  private xAxisName(index) {
    const names = {
      water: [
        'Point to point differential water consumption over selected time range',
        'Cumulative water consumption over selected time range'
      ],
      acid_chlorine: [
        'Acid inventory compound level in chemistry tank over selected time range',
        'Chlorine inventory compound level in chemistry tank over selected time range'
      ],
    };

    return names[this.selectedType][index];
  }

  private getChlorineOverTime() {
    let params = new HttpParams({encoder: new WebHttpUrlEncodingCodec()})
      .set('type', 'chlorine_level');

    if (this.selectedPark1) {
      params = params.append('parks[1]', this.selectedPark1)
        .append('from[1]', this.prepareDate(this.selectedFromDate1))
        .append('to[1]', this.prepareDate(this.selectedToDate1));
    }

    if (this.selectedPark2) {
      params = params.append('parks[2]', this.selectedPark2)
        .append('from[2]', this.prepareDate(this.selectedFromDate2))
        .append('to[2]', this.prepareDate(this.selectedToDate2));
    }

    return this.http.get<any>('/reports/conso', {params: params});
  }

  private processResult(result, index) {
    const legends = [];
    const dataLabels = result.labels;
    const series = [];

    Object.keys(result.values).forEach((id) => {
      const cap = this.prepareCaption(this.selectedType, index, id);

      legends.push(cap);

      series.push({
        name: cap,
        type: (this.selectedType !== 'water' || index !== 1) ? 'line' : 'bar',
        data: result.values[id]
      });
    });

    this.chartOptions[index] = {
      color: ['#4fc3f7', '#f74f8a'],
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      legend: {
        top: 20,
        data: legends
      },
      grid: {
        top: 80,
        left: 110,
        right: 75,
        bottom: 175,
        containLabel: false
      },
      toolbox: {
        show: false,
        orient: 'vertical',
        left: 'right',
        top: 'center',
        feature: {
          mark: {show: true},
          dataView: {show: true, readOnly: false},
          magicType: {show: true, type: ['line', 'bar', 'stack', 'tiled']},
          restore: {show: true},
          saveAsImage: {show: true}
        }
      },
      calculable: true,
      dataZoom: [
        {
          type: 'slider',
          show: true,
          start: 0,
          end: 100,
          left: 100,
          right: 105,
        }
      ],
      xAxis: [
        {
          type: 'category',
          data: dataLabels.map(val => moment.tz(val, 'UTC').format('MMM D HH:mm')),
          name: this.xAxisName(index),
          nameLocation: 'middle',
          nameGap: 120,
          axisLabel: {
            rotate: 90
          }
        }
      ],
      yAxis: [
        {
          type: 'value',
          name: (this.selectedType === 'water') ? 'Liters' : 'Percentage',
          nameLocation: 'middle',
          nameGap: 85,
        }
      ],
      series: series
    };
  }

  private reloadData() {
    let requests = [];

    if (this.selectedType === 'water') {
      requests = [this.getWaterOverTime(), this.getWaterCumulative()];
    } else if (this.selectedType === 'acid_chlorine') {
      requests = [this.getAcidOverTime(), this.getChlorineOverTime()];
    }

    if (requests.length < 1) {
      return;
    }

    this.chartOptions = [];

    this.isLoadingResults = true;

    forkJoin(requests).subscribe((results) => {
      this.isLoadingResults = false;

      results.forEach((result, index) => {
        this.processResult(result, index);
      });
    }, (error) => {
      this.isLoadingResults = false;
      console.log(error);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/reports/conso/reports.conso.component.ts